import { csrfToken, handleNotify, loading } from '@/modules/helper';

const ajax = async (options) => {
  if (options.data) alert('Attribute `data` is deprecated, use: `body`.');
  if (options.type) alert('Attribute `type` is deprecated, use: `method`.');

  options.loading ? options.loading(true) : loading(true);

  const headers = getHeader(options);
  const method = getMethod(options);
  const url = getURL(options);
  const attributes = { headers, method };

  if (options.keepalive) attributes.keepalive = true;
  if (options.sameOrigin) attributes.credentials = 'same-origin';

  let json;
  let response;

  if (!['GET', 'HEAD'].includes(method)) attributes.body = getBody(options);

  try {
    response = await fetch(url, attributes);

    json = response.status === 204 ? {} : await response.json();

    if (response.ok) return done(json, response, options);

    fail(json, response, options);
  } catch (error) {
    console.error(`[ajax] error: ${error}`);

    fail({ error }, response, options);
  } finally {
    always(json, response, options);
  }
};

const ajaxHandle = (data, statusText, status, options) => {
  const json = data || { details: statusText, title: 'Houston, we have a problem!' };

  switch (status) {
    case 302:
      if (!options.skipNotify) handleNotify(json);

      redirect(json);

      break;

    case 401:
      window.location.href = '/login';

      break;

    default:
      if (!options.skipNotify) handleNotify(json);
  }
};

const always = (json, response, options) => {
  options.loading ? options.loading(false) : loading(false);

  if (options.always) options.always(json, response);
};

const done = (json, response, options) => {
  ajaxHandle(json, response?.statusText, response?.status, options);

  if (options.done) options.done(json, response);
};

const fail = (json, response, options) => {
  ajaxHandle(json, response?.statusText, response?.status || 422, options);

  if (options.fail) options.fail(json, response);
};

const getBody = (options) => {
  return options.form ? new URLSearchParams(new FormData(options.form)) : JSON.stringify(options.body);
};

const getHeader = (options) => ({
  'Accept': 'application/json',
  'Content-Type': options.form ? 'multipart/form-data' : 'application/json',
  'X-Csrf-Token': csrfToken(),
  ...options.headers,
});

const getMethod = (options) => options.method || 'GET';

const getURL = (options) => {
  const params = options.params;

  if (!params) return options.url;

  const query = new URLSearchParams(params).toString();

  return `${options.url}?${query}`;
};

const redirect = (json) => {
  if (json.url) {
    let timeout = json.timeout || 1000;

    setTimeout(() => (window.location.href = json.url), timeout);
  }
};

export default ajax;
